export default __webpack_public_path__ + "static/offer-installation-4d8cc267669396f94bffb1ca534deae8.png";